<template lang="pug">
  el-form(ref="form" @submit.native.prevent='' label-position="top" :rules="rules" :model="location")

    el-row(:gutter="40")
      el-col(:lg="17")
        el-form-item(label="Location name" prop="name")
          el-input(v-model.trim="location.name" size='large' :autofocus='true')

      el-col(:lg="7")
        .schedule
          .schedule-header
          .schedule-content
            .schedule-actions
              el-button(type='primary' size='large' native-type='submit' @click="onSave") Save
              el-button(v-if='showDelete' type='text' @click="onDelete") Delete

            slot(name='saveOptions')

</template>

<script>
export default {
  model: {
    prop: "location",
    event: "change"
  },
  props: {
    create: {
      type: Boolean,
      default: true
    },
    location: {
      type: Object,
      default: () => ({})
    },
    showDelete: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      formSubmitted: false,
      rules: {
        name: [{ required: true, message: "Required field", trigger: "blur" }]
      }
    };
  },
  methods: {
    onSave() {
      this.$refs.form.validate(valid => {
        this.$emit("save", { valid });
      });
    },
    onDelete() {
      this.$emit("delete");
    }
  }
};
</script>

<style scoped lang="scss">
.schedule {
  display: flex;
  flex-direction: column;
  border-radius: 0 0 2px 2px;
}

.schedule-header {
  flex: 0 0 auto;
  background: #eee;
  padding: 10px;
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 2px 2px 0 0;
}

.schedule-status-label {
  margin-right: 10px;
  font-family: "gilroyextrabold";
  text-transform: uppercase;
  font-weight: normal;
  letter-spacing: 0.05em;
  font-size: 14px;
  color: #2c3e50;
}

.schedule-content {
  background: white;
  padding: 15px;
  border: 1px solid #ddd;
  border-top: 0;
  border-radius: 0 0 2px 2px;

  :global(.el-form-item) {
    margin-bottom: 5px;
  }
}

.schedule-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  :global(.el-button) {
    width: 100%;
    margin-left: 0;
    margin-bottom: 5px;
  }
}
</style>
